class AAPlaybookEngine {
  constructor(root) {
    this.root = root;

  this.template = this.getConfig('AAPlaybookTemplate');
this.sectionConfig = this.getConfig('AAPlaybookSectionConfig');
this.fieldConfig = this.getConfig('AAPlaybookFieldConfig');

const workspace = window.AAWorkspaceContext.get();

this.playbookId = workspace.playbookId;
this.playbook = null;
this.saveTimers = {};
this.saveStatus = 'saved';
this.reopenExpiryTimer = null;

const params =
  new URLSearchParams(window.location.search);

this.reviewMode =
  params.get('aa_review') === '1';

this.init();

    
  }

  getConfig(id) {
    const element = document.getElementById(id);

    if (!element) return null;

    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      console.error(`Unable to parse ${id}.`, error);
      return null;
    }
  }

  getSectionSnippets() {
  return Array.from(document.querySelectorAll('[data-aa-playbook-section]'))
    .map((element) => {
      try {
        return JSON.parse(element.textContent);
      } catch (error) {
        console.error('Unable to parse Playbook section.', error);
        return null;
      }
    })
    .filter(Boolean);
}

normalizeRegistryCollection(collection) {
  if (!collection) return [];

  if (Array.isArray(collection)) return collection;

  if (Array.isArray(collection.sections)) return collection.sections;

  if (Array.isArray(collection.fields)) return collection.fields;

  if (typeof collection === 'object') return Object.values(collection);

  return [];
}

resolveTemplateSections() {
  const templateSections = this.normalizeRegistryCollection(this.template?.sections);
  const sectionRegistry = this.normalizeRegistryCollection(this.sectionConfig);
  const fieldRegistry = this.normalizeRegistryCollection(this.fieldConfig);

  if (!templateSections.length || !sectionRegistry.length) {
    return this.getSectionSnippets();
  }

  return templateSections
    .map((templateSection) => {
      const sectionId = typeof templateSection === 'string'
        ? templateSection
        : templateSection.id || templateSection.sectionId;

      const registrySection = sectionRegistry.find((section) => section.id === sectionId);

      if (!registrySection) return null;

      const sectionFields = this.normalizeRegistryCollection(
        registrySection.fields || templateSection.fields
      );

      const resolvedFields = sectionFields
        .map((fieldReference) => {
          const fieldId = typeof fieldReference === 'string'
            ? fieldReference
            : fieldReference.id || fieldReference.fieldId;

          const registryField = fieldRegistry.find((field) => field.id === fieldId);

          return {
            ...(registryField || {}),
            ...(typeof fieldReference === 'object' ? fieldReference : {})
          };
        })
        .filter((field) => field.id);

      return {
        ...registrySection,
        ...(typeof templateSection === 'object' ? templateSection : {}),
        fields: resolvedFields.length ? resolvedFields : sectionFields
      };
    })
    .filter(Boolean);
}

getRegistrySections() {
  const registrySections =
    this.resolveTemplateSections();

  return registrySections.length
    ? registrySections
    : this.getSectionSnippets();
}

normalizeClientTemplateFieldType(type) {
  const key =
    String(type || '')
      .trim()
      .toLowerCase();

  const types = {
    'single line text': 'single_line_text',
    'paragraph': 'paragraph',
    'number': 'number',
    'currency': 'currency',
    'date': 'date',
    'time': 'time',
    'url': 'url',
    'email': 'email',
    'phone': 'phone',
    'dropdown': 'dropdown',
    'multi select': 'multi_select',
    'checkbox': 'checkbox',
    'toggle': 'toggle',
    'image upload': 'upload_placeholder',
    'file upload': 'upload_placeholder',
    'rich text': 'rich_text_placeholder'
  };

  return types[key] || type;
}

applyClientTemplateSections(
  registrySections,
  clientSections
) {
  if (
    !Array.isArray(clientSections) ||
    !clientSections.length
  ) {
    return registrySections;
  }

  const registryById =
    new Map(
      (registrySections || []).map(
        (section) => [
          String(section.id),
          section
        ]
      )
    );

  return [...clientSections]
    .filter(
      (section) =>
        section &&
        section.enabled !== false
    )
    .sort(
      (a, b) =>
        Number(a.displayOrder || 100) -
        Number(b.displayOrder || 100)
    )
    .map((clientSection) => {
      const registrySection =
        registryById.get(
          String(clientSection.id)
        ) || {};

      const fields =
        Array.isArray(clientSection.fields)
          ? clientSection.fields.map(
              (field) => ({
                ...field,
                type:
                  this.normalizeClientTemplateFieldType(
                    field.type
                  )
              })
            )
          : (
              registrySection.fields ||
              []
            );

      return {
        ...registrySection,
        ...clientSection,

        visible:
          clientSection.enabled !== false,

        order:
          Number(
            clientSection.displayOrder ||
            registrySection.order ||
            100
          ),

        repeatable:
          clientSection.rowRules
            ?.repeatable === true,

        maxRows:
          Number(
            clientSection.rowRules
              ?.maximumRows ||
            registrySection.maxRows ||
            1
          ),

        addButtonLabel:
          clientSection.rowRules
            ?.addButtonText ||
          registrySection.addButtonLabel ||
          'Add Entry',

        fields
      };
    });
}

renderAdminReviewControl() {
  const params =
    new URLSearchParams(window.location.search);

  const adminClientId =
    params.get('aa_admin_client');

  if (!adminClientId) {
    return;
  }

  const summaryCard =
    document.querySelector(
      '.aa-playbook__summary-card'
    );

  if (!summaryCard) {
    return;
  }

  /* Internal page wording */

  const pageTitle =
    document.querySelector(
      '.aa-workspace__page-title'
    );

  if (pageTitle) {
    pageTitle.textContent =
      this.reviewMode
        ? 'Playbook Review'
        : 'Playbook Editor';
  }

  const heroDescription =
    document.querySelector(
      '.aa-playbook__hero p:not(.aa-workspace__eyebrow)'
    );

  if (heroDescription) {
    heroDescription.textContent =
      this.reviewMode
        ? 'Review the client’s saved marketing plan and section completion.'
        : 'Editing this client Playbook in Headquarters. Changes autosave.';
  }

  /* Review / edit toggle */

  let button =
    summaryCard.querySelector(
      '[data-aa-admin-review-toggle]'
    );

  if (!button) {
    button = document.createElement('button');

    button.type = 'button';
    button.className =
      'aa-button aa-button--small';

    button.setAttribute(
      'data-aa-admin-review-toggle',
      ''
    );

    summaryCard.appendChild(button);
  }

  button.textContent =
    this.reviewMode
      ? 'Edit Playbook'
      : 'Return to Review';

  button.addEventListener(
    'click',
    () => {
      const url =
        new URL(window.location.href);

      if (this.reviewMode) {
        url.searchParams.delete(
          'aa_review'
        );
      } else {
        url.searchParams.set(
          'aa_review',
          '1'
        );
      }

      window.location.href =
        `${url.pathname}${url.search}${url.hash}`;
    },
    { once: true }
  );

  /* Back to selected client in Headquarters */

  const headerActions =
    document.querySelector(
      '.aa-workspace__header-actions'
    );

  if (
    headerActions &&
    !headerActions.querySelector(
      '[data-aa-back-to-headquarters]'
    )
  ) {
    const backLink =
      document.createElement('a');

    backLink.className =
      'aa-button aa-button--secondary aa-button--small';

    backLink.setAttribute(
      'data-aa-back-to-headquarters',
      ''
    );

    backLink.href =
      `/pages/artisans-avenue-clients?aa_client=${encodeURIComponent(adminClientId)}`;

    backLink.textContent =
      'Back to Headquarters';

    headerActions.prepend(backLink);
  }
}

 async init() {
  try {
    const allowed = await this.loadSavedValues();

    if (!allowed) {
      this.renderUnavailablePlaybook();
      return;
    }
  } catch (error) {
    console.error('Unable to confirm Playbook ownership:', error);
    this.renderUnavailablePlaybook();
    return;
  }

  let sections =
    this.getRegistrySections();

  const workspace =
    window.AAWorkspaceContext?.get?.();

  const clientId = workspace?.clientId;

  const snapshotSections =
    Array.isArray(
      this.playbook
        ?.template_snapshot
        ?.sections
    )
      ? this.playbook
          .template_snapshot
          .sections
      : [];

  if (snapshotSections.length) {
    sections =
      this.applyClientTemplateSections(
        sections,
        snapshotSections
      );
  } else if (
    clientId &&
    window.AAPlaybookService
      ?.getClientTemplateConfiguration
  ) {
    const clientTemplate =
      await window.AAPlaybookService
        .getClientTemplateConfiguration({
          clientId,
          month:
            this.playbook?.month,
          year:
            this.playbook?.year
        });

    if (
      Array.isArray(
        clientTemplate?.sections
      ) &&
      clientTemplate.sections.length
    ) {
      sections =
        this.applyClientTemplateSections(
          sections,
          clientTemplate.sections
        );
    }
  }

  if (!sections.length) {
    this.renderEmptyState();
    return;
  }

  this.renderSections(sections);

this.initializeSectionOpenState();
this.bindSectionOpenActions();

this.initializeSectionCompletion(
  sections
);

  this.bindSectionCompletion();
  this.updatePlaybookProgress();

  this.bindAutosave();
  this.bindFileUploads();
  this.hydrateSavedPlaybookFiles();
  this.bindRepeatableActions();
  this.bindLifecycleActions();
  this.renderAdminReviewControl();
}

async loadSavedValues() {
  const workspace = window.AAWorkspaceContext?.get?.();
  const clientId = workspace?.clientId;

  if (!clientId || !window.AAPlaybookService?.loadPlaybookById) {
    return false;
  }

  const params = new URLSearchParams(window.location.search);
  const requestedPlaybookId = params.get('playbook');
  const playbookId = requestedPlaybookId || workspace.playbookId;

  // An empty current Playbook is allowed. Explicit invalid links are not.
  if (!playbookId) return true;

  const result = await window.AAPlaybookService.loadPlaybookById({
    playbookId,
    clientId
  });

  if (!result?.playbook ||
      String(result.playbook.client_id) !== String(clientId)) {
    this.savedValues = {};
    this.playbook = null;
    this.playbookId = null;
    return false;
  }

  this.playbook = result.playbook;
  this.playbookId = result.playbook.id;
  this.savedValues = requestedPlaybookId
    ? (result.values || {})
    : this.normalizeSavedValues(result.values || {});

  if (typeof this.updatePlaybookHeader === 'function') {
    this.updatePlaybookHeader();
  }

  return true;
}

normalizeSavedValues(values) {
  const normalized = {};

  Object.entries(values || {}).forEach(
    ([key, value]) => {
      const isFileValue =
        Array.isArray(value) ||
        (
          value &&
          typeof value === 'object' &&
          value.path
        );

      if (isFileValue) {
        normalized[key] = value;
        return;
      }

      if (
        value &&
        typeof value === 'object'
      ) {
        Object.entries(value).forEach(
          ([fieldId, fieldValue]) => {
            normalized[fieldId] =
              fieldValue;
          }
        );

        return;
      }

      normalized[key] = value;
    }
  );

  return normalized;
}

  renderSections(sections) {
    const visibleSections = sections
  .filter(
    (section) =>
      section.visible !== false &&
      section.enabled !== false
  )
      .sort((a, b) => (a.order || 100) - (b.order || 100));

    this.root.innerHTML = visibleSections
      .map((section) => this.renderSection(section))
      .join('');
  }

renderSection(section) {
  const hasVisualLayout =
    Array.isArray(section.fields) &&
    section.fields.some(
      (field) =>
        field?.layout?.desktop ||
        field?.layout?.mobile
    );

  if (hasVisualLayout) {
    return this.renderGenericSection(section);
  }

  if (section.id === 'coupons') {
    return this.renderCouponSection(section);
  }

  if (section.id === 'classes') {
    return this.renderClassSection(section);
  }

  return this.renderGenericSection(section);
}

renderCouponSection(section) {
  const isExpanded = section.defaultExpanded !== false;
  const fields = (section.fields || []).filter((field) => {
    const key = `${field.id || ''} ${field.label || ''}`.toLowerCase();
    return !key.includes('description');
  });
  const repeatable = section.repeatable === true;
  const maxRows = Number(section.maxRows || 1);
  const addButtonLabel = section.addButtonLabel || 'Add Coupon';

  return `
    <section
      class="aa-playbook-form-section aa-playbook-form-section--coupons"
      data-section-id="${section.id}"
      data-section-expanded="${isExpanded}"
      data-repeatable="${repeatable}"
      data-max-rows="${maxRows}"
    >
      <header class="aa-playbook-form-section__header">
  <div class="aa-playbook-form-section__heading">
    <div class="aa-playbook-form-section__title-row">
      <h3>${section.title ?? section.internalTitle ?? 'Coupons'}</h3>
      ${section.required ? this.renderRequiredIndicator() : ''}
    </div>

    ${section.description ? `<p>${section.description}</p>` : ''}
    ${section.helpText ? `<small>${section.helpText}</small>` : ''}
  </div>

  <div class="aa-playbook-form-section__actions">
    <button
      class="aa-playbook-section-complete"
      type="button"
      data-aa-complete-section="${section.id}"
      aria-pressed="false"
    >
      Complete Section
    </button>
  </div>
</header>

      <div class="aa-playbook-form-section__body">
        <div class="aa-playbook-coupon-card">
          <div class="aa-playbook-coupon-card__header">
            <strong>Coupon #1</strong>
            <button type="button" class="aa-playbook-delete-row" data-aa-delete-row disabled>Delete Coupon</button>
          </div>

          <div class="aa-playbook-form-section__fields aa-playbook-form-section__fields--compact aa-playbook-coupon-entry">

  ${fields.filter(field => {
      const key = `${field.id || ''} ${field.label || ''}`.toLowerCase();
      return key.includes('title') || key.includes('name');
    }).map(field => this.renderCouponField(field)).join('')}

  ${fields.filter(field => {
      const key = `${field.id || ''} ${field.label || ''}`.toLowerCase();
      return key.includes('start');
    }).map(field => this.renderCouponField(field)).join('')}

  ${fields.filter(field => {
      const key = `${field.id || ''} ${field.label || ''}`.toLowerCase();
      return key.includes('end');
    }).map(field => this.renderCouponField(field)).join('')}

  ${fields.filter(field => {
      const key = `${field.id || ''} ${field.label || ''}`.toLowerCase();
      return key.includes('discount');
    }).map(field => this.renderCouponField(field)).join('')}

  ${fields.filter(field => {
      const key = `${field.id || ''} ${field.label || ''}`.toLowerCase();
      return key.includes('image') || key.includes('upload');
    }).map(field => this.renderCouponField(field)).join('')}

</div>
        </div>

        ${repeatable ? `
          <div class="aa-playbook-repeatable-controls">
            <button
              type="button"
              class="aa-playbook-add-row"
              data-aa-add-row="${section.id}"
              ${maxRows <= 1 ? 'disabled' : ''}
            >
              ${addButtonLabel}
            </button>

            <p class="aa-playbook-repeatable-limit" ${maxRows <= 1 ? '' : 'hidden'}>
              Maximum coupons reached.
            </p>
          </div>
        ` : ''}
      </div>
    </section>
  `;
}

renderCouponField(field) {
  const key = `${field.id || ''} ${field.label || ''}`.toLowerCase();

  if (key.includes('discount')) {
    return this.renderField({
      ...field,
      label: 'Discount',
      type: 'single_line_text',
      placeholder: '10% off, $25 off, BOGO',
      width: 'coupon-discount'
    });
  }

  if (key.includes('title') || key.includes('name')) {
    return this.renderField({
      ...field,
      label: 'Coupon Name',
      width: 'class-row-field'
    });
  }

  if (key.includes('start') || key.includes('from')) {
    return this.renderField({
      ...field,
      label: 'Start Date',
      width: 'class-row-field'
    });
  }

  if (key.includes('end') || key.includes('until')) {
    return this.renderField({
      ...field,
      label: 'End Date',
      width: 'class-row-field'
    });
  }

  if (key.includes('image') || key.includes('upload')) {
    return this.renderField({
      ...field,
      label: 'Coupon Image',
      width: 'coupon-image'
    });
  }

  return this.renderField(field);
}

renderClassSection(section) {
  const isExpanded = section.defaultExpanded !== false;
  const sourceFields = section.fields || [];
  const repeatable = section.repeatable === true;
  const maxRows = Number(section.maxRows || 1);
  const addButtonLabel = section.addButtonLabel || 'Add Class';

  const findField = (matches) => sourceFields.find((field) => {
    const key = `${field.id || ''} ${field.label || ''}`.toLowerCase();
    return matches.some((match) => key.includes(match));
  });

  const classFields = [
    findField(['class name', 'class title', 'name', 'title']) || { id: 'class_name', label: 'Class Name', type: 'single_line_text' },
    findField(['date']) || { id: 'class_date', label: 'Date', type: 'date' },
    findField(['start time']) || { id: 'class_start_time', label: 'Start Time', type: 'time' },
    findField(['end time']) || { id: 'class_end_time', label: 'End Time', type: 'time' },
    findField(['registration', 'link', 'url']) || { id: 'class_registration_link', label: 'Registration Link', type: 'url' },
    findField(['price', 'cost']) || { id: 'class_price', label: 'Price', type: 'single_line_text' },
    findField(['image', 'upload']) || { id: 'class_image', label: 'Class Image', type: 'upload_placeholder' },
    findField(['description']) || { id: 'class_description', label: 'Description', type: 'paragraph' }
  ];

  return `
    <section
      class="aa-playbook-form-section aa-playbook-form-section--classes"
      data-section-id="${section.id}"
      data-section-expanded="${isExpanded}"
      data-repeatable="${repeatable}"
      data-max-rows="${maxRows}"
    >
      <header class="aa-playbook-form-section__header">
  <div class="aa-playbook-form-section__heading">
    <div class="aa-playbook-form-section__title-row">
      <h3>${section.title ?? section.internalTitle ?? 'Classes'}</h3>
      ${section.required ? this.renderRequiredIndicator() : ''}
    </div>
  </div>

  <div class="aa-playbook-form-section__actions">
    <button
      class="aa-playbook-section-complete"
      type="button"
      data-aa-complete-section="${section.id}"
      aria-pressed="false"
    >
      Complete Section
    </button>
  </div>
</header>

      <div class="aa-playbook-form-section__body">
        <div class="aa-playbook-coupon-card aa-playbook-class-card">
          <div class="aa-playbook-coupon-card__header aa-playbook-class-card__header">
            <strong>Class #1</strong>
            <button type="button" class="aa-playbook-delete-row" data-aa-delete-row disabled>Delete Class</button>
          </div>

          <div class="aa-playbook-class-entry" style="display:flex;flex-direction:column;gap:12px;width:100%;">
            <div class="aa-playbook-class-row aa-playbook-class-row--top" style="display:grid;grid-template-columns:minmax(240px,1fr) 150px 150px 150px;gap:12px;align-items:end;width:100%;">
              ${classFields.slice(0, 4).map(field => this.renderClassField(field)).join('')}
            </div>

            <div class="aa-playbook-class-row aa-playbook-class-row--middle" style="display:grid;grid-template-columns:minmax(240px,1fr) 150px minmax(210px,280px);gap:12px;align-items:end;width:100%;">
              ${classFields.slice(4, 7).map(field => this.renderClassField(field)).join('')}
            </div>

            <div class="aa-playbook-class-row aa-playbook-class-row--bottom" style="display:block;width:100%;">
              ${classFields.slice(7).map(field => this.renderClassField(field)).join('')}
            </div>
          </div>
        </div>

        ${repeatable ? `
          <div class="aa-playbook-repeatable-controls">
            <button
              type="button"
              class="aa-playbook-add-row"
              data-aa-add-row="${section.id}"
              ${maxRows <= 1 ? 'disabled' : ''}
            >
              ${addButtonLabel}
            </button>

            <p class="aa-playbook-repeatable-limit" ${maxRows <= 1 ? '' : 'hidden'}>
              Maximum classes reached.
            </p>
          </div>
        ` : ''}
      </div>
    </section>
  `;
}

renderClassField(field) {
  const key = `${field.id || ''} ${field.label || ''}`.toLowerCase();

  if (key.includes('class name') || key.includes('class title') || key.includes('name') || key.includes('title')) {
    return this.renderField({
      ...field,
      label: 'Class Name',
      width: 'class-row-field'
    });
  }

  if (key.includes('date')) {
    return this.renderField({
      ...field,
      label: 'Date',
      type: 'date',
      width: 'class-row-field'
    });
  }

  if (key.includes('start time')) {
    return this.renderField({
      ...field,
      label: 'Start Time',
      type: 'time',
      width: 'class-row-field'
    });
  }

  if (key.includes('end time')) {
    return this.renderField({
      ...field,
      label: 'End Time',
      type: 'time',
      width: 'class-row-field'
    });
  }

  if (key.includes('registration') || key.includes('link') || key.includes('url')) {
    return this.renderField({
      ...field,
      label: 'Registration Link',
      type: 'url',
      width: 'class-row-field'
    });
  }

  if (key.includes('price') || key.includes('cost')) {
    return this.renderField({
      ...field,
      label: 'Price',
      width: 'class-row-field'
    });
  }

  if (key.includes('image') || key.includes('upload')) {
    return this.renderField({
      ...field,
      label: 'Class Image',
      type: 'upload_placeholder',
      width: 'class-row-field'
    });
  }

  if (key.includes('description')) {
    return this.renderField({
      ...field,
      label: 'Description',
      type: 'paragraph',
      width: 'class-row-field'
    });
  }

  return this.renderField(field);
}

renderGenericSection(section) {
  const isExpanded = section.defaultExpanded !== false;
  const fieldCount = Array.isArray(section.fields) ? section.fields.length : 0;
  const repeatable = section.repeatable === true;
  const maxRows = Number(section.maxRows || 1);
  const addButtonLabel = section.addButtonLabel || 'Add Entry';

  return `
    <section
      class="aa-playbook-form-section"
      data-section-id="${section.id}"
      data-section-expanded="${isExpanded}"
      data-repeatable="${repeatable}"
      data-max-rows="${maxRows}"
    >
      <header class="aa-playbook-form-section__header">
        <div class="aa-playbook-form-section__heading">
          <div class="aa-playbook-form-section__title-row">
            <h3>${section.title ?? section.internalTitle ?? 'Untitled Section'}</h3>
            ${section.required ? this.renderRequiredIndicator() : ''}
          </div>

          ${section.description ? `<p>${section.description}</p>` : ''}
          ${section.helpText ? `<small>${section.helpText}</small>` : ''}
        </div>

        <div class="aa-playbook-form-section__actions">
  <button
    class="aa-playbook-section-complete"
    type="button"
    data-aa-complete-section="${section.id}"
    aria-pressed="false"
  >
    Mark Complete
  </button>
</div>
</header>

      <div class="aa-playbook-form-section__body">
        <div class="aa-playbook-form-section__fields aa-playbook-form-section__fields--compact">
          ${(section.fields || []).map((field) => this.renderField(field)).join('')}
        </div>

        ${repeatable ? `
          <div class="aa-playbook-repeatable-controls">
            <button
              type="button"
              class="aa-playbook-add-row"
              data-aa-add-row="${section.id}"
              ${maxRows <= 1 ? 'disabled' : ''}
            >
              ${addButtonLabel}
            </button>

            <p class="aa-playbook-repeatable-limit" ${maxRows <= 1 ? '' : 'hidden'}>
              Maximum entries reached.
            </p>
          </div>
        ` : ''}
      </div>
    </section>
  `;
}

  renderField(field) {
    const width =
      String(field.width || '50%');

    const desktop =
      field?.layout?.desktop;

    const mobile =
      field?.layout?.mobile;

    const hasVisualLayout =
      Boolean(desktop || mobile);

    let layoutStyle = '';

    if (hasVisualLayout) {
      const desktopLayout =
        desktop || {
          row: 1,
          col: 1,
          span: 4
        };

      const mobileLayout =
        mobile || {
          row:
            desktopLayout.row,
          col: 1,
          span: 2
        };

      layoutStyle = [
        `--aa-desktop-row:${Number(desktopLayout.row) || 1}`,
        `--aa-desktop-col:${Number(desktopLayout.col) || 1}`,
        `--aa-desktop-span:${Number(desktopLayout.span) || 1}`,
        `--aa-mobile-row:${Number(mobileLayout.row) || 1}`,
        `--aa-mobile-col:${Number(mobileLayout.col) || 1}`,
        `--aa-mobile-span:${Number(mobileLayout.span) || 1}`
      ].join(';') + ';';
    } else if (width === 'class-row-field') {
      layoutStyle =
        'width:100%;max-width:none;';
    } else {
      const span =
        width === '25%'
          ? 1
          : width === '75%'
            ? 3
            : (
                width === '100%' ||
                width === 'full'
              )
              ? 4
              : 2;

      layoutStyle =
        `grid-column: ${field.startNewRow ? `1 / span ${span}` : `span ${span}`};`;
    }

    const widthClass =
      hasVisualLayout
        ? 'layout'
        : width.includes('%')
          ? 'layout'
          : width;

    return `
      <div
        class="aa-playbook-field aa-playbook-field--${widthClass}${hasVisualLayout ? ' aa-playbook-field--visual-layout' : ''}"
        data-field-id="${field.id}"
        data-field-type="${field.type}"
        data-field-width="${width}"
        style="${layoutStyle}"
      >
        <label class="aa-playbook-field__label">
          ${field.label || 'Untitled Field'}
          ${field.required ? '<span class="aa-playbook-field__required">*</span>' : ''}
        </label>

        ${this.renderFieldInput(field)}

        ${field.helpText ? this.renderHelpText(field.helpText) : ''}
      </div>
    `;
  }

  renderFieldInput(field) {
    const placeholder = field.placeholder || '';
const savedValue = this.savedValues?.[field.id] ?? '';

    switch (field.type) {
      case 'paragraph':
       return `<textarea
  class="aa-playbook-input aa-playbook-textarea"
  placeholder="${placeholder}"
>${savedValue}</textarea>`;

      case 'number':
        return `<input class="aa-playbook-input" type="number" placeholder="${placeholder}" value="${savedValue}">`;

      case 'currency':
        return `<input class="aa-playbook-input" type="number" placeholder="${placeholder || '$0.00'}" value="${savedValue}">`;

      case 'date':
        return `<input class="aa-playbook-input" type="date" value="${savedValue}">`;

      case 'time':
        return `<input class="aa-playbook-input" type="time" value="${savedValue}">`;

      case 'url':
        return `<input class="aa-playbook-input" type="url" placeholder="${placeholder}" value="${savedValue}">`;

      case 'email':
        return `<input class="aa-playbook-input" type="email" placeholder="${placeholder}" value="${savedValue}">`;

      case 'phone':
       return `<input
  class="aa-playbook-input"
  type="tel"
  placeholder="${placeholder}"
  value="${savedValue}"
>`;

      case 'dropdown':
        return this.renderSelect(field);

      case 'multi_select':
        return this.renderMultiSelect(field);

    
        case 'checkbox':
  return `<label class="aa-playbook-checkbox">
    <input type="checkbox" ${savedValue === true || savedValue === 'true' ? 'checked' : ''}>
    ${field.checkboxLabel || 'Checkbox option'}
  </label>`;

      case 'toggle':
        return `<label class="aa-playbook-toggle">
  <input type="checkbox" ${savedValue === true || savedValue === 'true' ? 'checked' : ''}>
  <span></span>
</label>`;

      case 'upload_placeholder': {
  const maxUploads =
    Number(field.maxUploads || 5);

  return `<div
    class="aa-playbook-placeholder aa-playbook-upload-placeholder"
    data-uploads-allowed="${field.uploadsAllowed !== false}"
    data-max-uploads="${maxUploads}"
  >
    <div class="aa-playbook-upload-picker">
      <input
        class="aa-playbook-input"
        type="file"
        accept=".jpg,.jpeg,.png,.webp,.pdf,image/jpeg,image/png,image/webp,application/pdf"
        ${maxUploads > 1 ? 'multiple' : ''}
      >
    </div>

    <div
      class="aa-playbook-upload-saved"
      data-aa-playbook-saved-file
    ></div>

    <small
      class="aa-playbook-upload-status"
      data-aa-playbook-upload-status
    ></small>
  </div>`;
}

      case 'rich_text_placeholder':
        return `<div class="aa-playbook-placeholder">Rich text placeholder</div>`;

      case 'repeating_group_placeholder':
        return `<div class="aa-playbook-placeholder">Repeating group placeholder</div>`;

      case 'single_line_text':
      default:
        return `<input
  class="aa-playbook-input"
  type="text"
  placeholder="${placeholder}"
  value="${savedValue}"
>`;
    }
  }

  renderSelect(field) {
    const options = field.options || [];
    const savedValue = this.savedValues?.[field.id] ?? '';

 return `
  <select class="aa-playbook-input">
    <option value="">Select an option</option>
    ${options.map((option) => `
      <option value="${option}" ${savedValue === option ? 'selected' : ''}>${option}</option>
    `).join('')}
  </select>
`;
  }

  renderMultiSelect(field) {
  const options = field.options || [];
  const savedValue = this.savedValues?.[field.id] || [];
  const savedValues = Array.isArray(savedValue) ? savedValue : [];

  if (!options.length) {
    return `<div class="aa-playbook-placeholder">Multi-select placeholder</div>`;
  }

  return `
    <div class="aa-playbook-multi-select">
      ${options.map((option) => `
        <label>
          <input type="checkbox" value="${option}" ${savedValues.includes(option) ? 'checked' : ''}>
          ${option}
        </label>
      `).join('')}
    </div>
  `;
}
  renderRequiredIndicator() {
    return `<span class="aa-required-indicator">Required</span>`;
  }

  renderHelpText(text) {
  return `<p class="aa-playbook-field__help">${text}</p>`;
}

getSectionCompletionFieldId(sectionId) {
  return `__section_complete__:${sectionId}`;
}

getSectionOpenFieldId(sectionId) {
  return `__section_open__:${sectionId}`;
}

hasSavedSectionOpenState(sectionId) {
  const fieldId =
    this.getSectionOpenFieldId(sectionId);

  return Object.prototype.hasOwnProperty.call(
    this.savedValues || {},
    fieldId
  );
}

isSectionOpen(sectionId, defaultOpen = false) {
  const fieldId =
    this.getSectionOpenFieldId(sectionId);

  if (
    !this.hasSavedSectionOpenState(
      sectionId
    )
  ) {
    return defaultOpen;
  }

  const value =
    this.savedValues?.[fieldId];

  return value === true ||
    value === 'true';
}

applySectionOpenState(
  sectionElement,
  open
) {
  if (!sectionElement) {
    return;
  }

  const body =
    sectionElement.querySelector(
      '.aa-playbook-form-section__body'
    );

  const header =
    sectionElement.querySelector(
      '.aa-playbook-form-section__header'
    );

  if (body) {
    body.hidden = !open;
  }

  sectionElement.dataset.sectionExpanded =
    open ? 'true' : 'false';

  if (header) {
    header.setAttribute(
      'aria-expanded',
      open ? 'true' : 'false'
    );
  }
}

async saveSectionOpenState(
  sectionId,
  open
) {
  if (
    !sectionId ||
    !this.playbookId ||
    !window.AAPlaybookService
  ) {
    return false;
  }

  const fieldId =
    this.getSectionOpenFieldId(
      sectionId
    );

  const success =
    await window.AAPlaybookService
      .saveField({
        playbookId:
          this.playbookId,

        sectionId:
          '__playbook_ui__',

        fieldId,

        value:
          open === true
      });

  if (success) {
    this.savedValues[fieldId] =
      open === true;
  }

  return success;
}

isSectionComplete(sectionId) {
  const fieldId =
    this.getSectionCompletionFieldId(sectionId);

  const value =
    this.savedValues?.[fieldId];

  return value === true || value === 'true';
}

applySectionCompletionState(
  sectionElement,
  completed
) {
  if (!sectionElement) return;

  const button =
    sectionElement.querySelector(
      '[data-aa-complete-section]'
    );

  sectionElement.classList.toggle(
    'is-complete',
    completed
  );

  if (!button) return;

  button.setAttribute(
    'aria-pressed',
    completed ? 'true' : 'false'
  );

  button.textContent =
    completed
      ? 'Completed'
      : 'Mark Complete';
}

reorderSectionsByCompletion() {
  const sections =
    Array.from(
      this.root.querySelectorAll(
        ':scope > [data-section-id]'
      )
    );

  sections
    .sort((a, b) => {
      const aComplete =
        a.classList.contains('is-complete');

      const bComplete =
        b.classList.contains('is-complete');

      if (aComplete !== bComplete) {
        return aComplete ? 1 : -1;
      }

      return (
        Number(a.dataset.originalOrder || 0) -
        Number(b.dataset.originalOrder || 0)
      );
    })
    .forEach((section) => {
      this.root.appendChild(section);
    });
}

initializeSectionOpenState() {
  const sectionElements =
    Array.from(
      this.root.querySelectorAll(
        ':scope > [data-section-id]'
      )
    );

  sectionElements.forEach(
    (sectionElement, index) => {
      const sectionId =
        sectionElement.dataset.sectionId;

      if (!sectionId) {
        return;
      }

      const header =
        sectionElement.querySelector(
          '.aa-playbook-form-section__header'
        );

      if (header) {
        header.setAttribute(
          'data-aa-section-toggle-surface',
          ''
        );
        header.tabIndex = 0;
      }

      const legacyToggle =
        sectionElement.querySelector(
          '[data-aa-toggle-section]'
        );

      if (legacyToggle) {
        legacyToggle.remove();
      }

      /*
       * Brand-new Playbook:
       * first visible section open,
       * everything else collapsed.
       *
       * Once a saved state exists,
       * use that instead.
       */
      const open =
        this.isSectionOpen(
          sectionId,
          index === 0
        );

      this.applySectionOpenState(
        sectionElement,
        open
      );
    }
  );
}

bindSectionOpenActions() {
  const toggleSection =
    async (sectionElement) => {
      const sectionId =
        sectionElement
          ?.dataset.sectionId;

      if (
        !sectionElement ||
        !sectionId
      ) {
        return;
      }

      const currentlyOpen =
        sectionElement
          .dataset
          .sectionExpanded ===
        'true';

      const nextOpen =
        !currentlyOpen;

      this.applySectionOpenState(
        sectionElement,
        nextOpen
      );

      const canSave =
        !this.reviewMode &&
        this.playbook &&
        window.AAPlaybookService
          ?.canEditPlaybook(
            this.playbook
          );

      if (canSave) {
        await this
          .saveSectionOpenState(
            sectionId,
            nextOpen
          );
      }
    };

  this.root
    .querySelectorAll(
      '[data-aa-section-toggle-surface]'
    )
    .forEach((header) => {
      header.addEventListener(
        'click',
        (event) => {
          if (
            event.target.closest(
              'button, a, input, textarea, select, label, [contenteditable="true"]'
            )
          ) {
            return;
          }

          toggleSection(
            header.closest(
              '[data-section-id]'
            )
          );
        }
      );

      header.addEventListener(
        'keydown',
        (event) => {
          if (
            event.target !== header ||
            !['Enter', ' '].includes(
              event.key
            )
          ) {
            return;
          }

          event.preventDefault();

          toggleSection(
            header.closest(
              '[data-section-id]'
            )
          );
        }
      );
    });
}

initializeSectionCompletion(sections = []) {
  const visibleSections = sections
  .filter(
    (section) =>
      section.visible !== false &&
      section.enabled !== false
  );

  const canEdit =
  !this.reviewMode &&
  this.playbook &&
  window.AAPlaybookService?.canEditPlaybook(
    this.playbook
  );

  this.root
  .querySelectorAll('[data-section-id]')
  .forEach((sectionElement, index) => {
    sectionElement.dataset.originalOrder =
      String(index);
      const sectionId =
        sectionElement.dataset.sectionId;

      const completed =
        this.isSectionComplete(sectionId);

      this.applySectionCompletionState(
        sectionElement,
        completed
      );

      const button =
        sectionElement.querySelector(
          '[data-aa-complete-section]'
        );

      if (button) {
        button.disabled = !canEdit;
      }
    });

  if (
    canEdit &&
    this.playbookId &&
    window.AAPlaybookService
      ?.savePlaybookSectionCount
  ) {
    window.AAPlaybookService
      .savePlaybookSectionCount({
        playbookId: this.playbookId,
        totalSections: visibleSections.length
      })
      .then((success) => {
        if (!success) {
          console.error(
            'Unable to save Playbook section count.'
          );
        }
      });
  }

  this.reorderSectionsByCompletion();
}

bindSectionCompletion() {
  this.root
    .querySelectorAll('[data-aa-complete-section]')
    .forEach((button) => {
      button.addEventListener(
        'click',
        async () => {
          const sectionElement =
            button.closest('[data-section-id]');

          const sectionId =
            sectionElement?.dataset.sectionId;

          if (
            !sectionElement ||
            !sectionId ||
            !this.playbookId ||
            !window.AAPlaybookService
          ) {
            return;
          }

          const canEdit =
  !this.reviewMode &&
  window.AAPlaybookService
    .canEditPlaybook(this.playbook);

          if (!canEdit) {
            return;
          }

          const currentlyComplete =
            this.isSectionComplete(sectionId);

          const nextComplete =
            !currentlyComplete;

          button.disabled = true;
          button.textContent = 'Saving...';

          const success =
            await window.AAPlaybookService
              .saveSectionCompletion({
                playbookId: this.playbookId,
                sectionId,
                completed: nextComplete
              });

          if (!success) {
            button.disabled = false;

            this.applySectionCompletionState(
              sectionElement,
              currentlyComplete
            );

            return;
          }

          const fieldId =
            this.getSectionCompletionFieldId(
              sectionId
            );

          this.savedValues[fieldId] =
            nextComplete;

          this.applySectionCompletionState(
  sectionElement,
  nextComplete
);

if (nextComplete) {
  this.applySectionOpenState(
    sectionElement,
    false
  );

  await this.saveSectionOpenState(
    sectionId,
    false
  );
}

this.reorderSectionsByCompletion();

if (nextComplete) {
  const nextSection =
    Array.from(
      this.root.querySelectorAll(
        ':scope > [data-section-id]'
      )
    )
      .find((candidate) => {
        const candidateId =
          candidate.dataset.sectionId;

        return (
          candidateId &&
          !this.isSectionComplete(
            candidateId
          )
        );
      });

  if (nextSection) {
    const nextSectionId =
      nextSection.dataset.sectionId;

    this.applySectionOpenState(
      nextSection,
      true
    );

    await this.saveSectionOpenState(
      nextSectionId,
      true
    );
  }
}

await this.updatePlaybookProgress();

button.disabled = false;
        }
      );
    });
}

async updatePlaybookProgress() {
  if (
    !this.playbookId ||
    !window.AAPlaybookService?.getPlaybookCompletion
  ) {
    return;
  }

  const completion =
    await window.AAPlaybookService.getPlaybookCompletion({
      playbookId: this.playbookId
    });

  if (!completion) {
    return;
  }

  const summaryCard =
    document.querySelector(
      '.aa-playbook__summary-card'
    );

  if (!summaryCard) {
    return;
  }

  let progress =
    summaryCard.querySelector(
      '[data-aa-playbook-progress]'
    );

  if (!progress) {
    progress = document.createElement('div');

    progress.className =
      'aa-playbook-progress-summary';

    progress.setAttribute(
      'data-aa-playbook-progress',
      ''
    );

    progress.innerHTML = `
      <div class="aa-playbook-progress-summary__meta">
        <span>Progress</span>
        <strong data-aa-playbook-progress-percent></strong>
      </div>

      <div class="aa-playbook-progress-summary__bar">
        <span data-aa-playbook-progress-bar></span>
      </div>

      <small data-aa-playbook-progress-count></small>
    `;

    const actions =
      summaryCard.querySelector(
        '[data-aa-playbook-actions]'
      );

    if (actions) {
      summaryCard.insertBefore(
        progress,
        actions
      );
    } else {
      summaryCard.appendChild(progress);
    }
  }

  const percent =
    progress.querySelector(
      '[data-aa-playbook-progress-percent]'
    );

  const bar =
    progress.querySelector(
      '[data-aa-playbook-progress-bar]'
    );

  const count =
    progress.querySelector(
      '[data-aa-playbook-progress-count]'
    );

  if (percent) {
    percent.textContent =
      `${completion.percentage}%`;
  }

  if (bar) {
    bar.style.width =
      `${completion.percentage}%`;
  }

  if (count) {
    count.textContent =
      `${completion.completedSections} of ${completion.totalSections} sections complete`;
  }
}

getSavedPlaybookFiles(fieldId) {
  const value =
    this.savedValues?.[fieldId];

  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    return value.filter(
      (file) =>
        file &&
        typeof file === 'object' &&
        file.path
    );
  }

  if (
    typeof value === 'object' &&
    value.path
  ) {
    return [value];
  }

  return [];
}

getUploadLimit(fieldWrapper) {
  return Math.max(
    1,
    Number(
      fieldWrapper
        ?.querySelector(
          '[data-max-uploads]'
        )
        ?.dataset.maxUploads ||
      fieldWrapper
        ?.querySelector(
          '.aa-playbook-upload-placeholder'
        )
        ?.dataset.maxUploads ||
      5
    )
  );
}

async renderSavedPlaybookFiles(
  fieldWrapper
) {
  if (!fieldWrapper) {
    return;
  }

  const fieldId =
    fieldWrapper.dataset.fieldId;

  const files =
    this.getSavedPlaybookFiles(
      fieldId
    );

  const container =
    fieldWrapper.querySelector(
      '[data-aa-playbook-saved-file]'
    );

  const status =
    fieldWrapper.querySelector(
      '[data-aa-playbook-upload-status]'
    );

  const uploadBox =
    fieldWrapper.querySelector(
      '.aa-playbook-upload-placeholder'
    );

  const input =
    fieldWrapper.querySelector(
      'input[type="file"]'
    );

  if (!container) {
    return;
  }

  const maxUploads =
    Number(
      uploadBox?.dataset.maxUploads ||
      5
    );

  container.innerHTML = '';

  if (status) {
    status.textContent =
      files.length
        ? `${files.length} of ${maxUploads} files uploaded`
        : `Up to ${maxUploads} files`;
  }

  if (input) {
    input.disabled =
      this.reviewMode ||
      !this.playbook ||
      !window.AAPlaybookService
        ?.canEditPlaybook(
          this.playbook
        ) ||
      files.length >= maxUploads;
  }

  if (!files.length) {
    return;
  }

  const section =
    fieldWrapper.closest(
      '[data-section-id]'
    );

  const sectionId =
    section?.dataset.sectionId;

  const canEdit =
    !this.reviewMode &&
    this.playbook &&
    window.AAPlaybookService
      ?.canEditPlaybook(
        this.playbook
      );

  for (
    let index = 0;
    index < files.length;
    index += 1
  ) {
    const file =
      files[index];

    const row =
      document.createElement('div');

    row.className =
      'aa-playbook-upload-file';

    const name =
      document.createElement('span');

    name.className =
      'aa-playbook-upload-file__name';

    name.textContent =
      file.fileName ||
      'Uploaded file';

    const actions =
      document.createElement('div');

    actions.className =
      'aa-playbook-upload-file__actions';

    try {
      const signedUrl =
        await window
          .AASupabaseClient
          .getPlaybookFileSignedUrl({
            path: file.path,
            expiresIn: 3600
          });

      const view =
        document.createElement('a');

      view.href = signedUrl;
      view.target = '_blank';
      view.rel = 'noopener';
      view.textContent = 'View';

      actions.appendChild(view);
    } catch (error) {
      console.error(
        'Unable to load Playbook file:',
        error
      );
    }

    if (
      canEdit &&
      sectionId &&
      window.AASupabaseClient
        ?.deletePlaybookFile
    ) {
      const remove =
  document.createElement(
    'button'
  );

remove.type = 'button';
remove.textContent = 'Remove';

const cancel =
  document.createElement(
    'button'
  );

cancel.type = 'button';
cancel.textContent = 'Cancel';
cancel.hidden = true;

remove.addEventListener(
  'click',
  async () => {
    const confirming =
      remove.dataset.confirming ===
      'true';

    if (!confirming) {
      remove.dataset.confirming =
        'true';

      remove.textContent =
        'Confirm Remove';

      cancel.hidden = false;

      return;
    }

    remove.disabled = true;
    cancel.disabled = true;

    remove.textContent =
      'Removing...';

    const nextFiles =
      files.filter(
        (_, fileIndex) =>
          fileIndex !== index
      );

    const success =
      await window
        .AAPlaybookService
        .saveField({
          playbookId:
            this.playbookId,
          sectionId,
          fieldId,
          value: nextFiles
        });

    if (!success) {
      remove.disabled = false;
      cancel.disabled = false;

      remove.dataset.confirming =
        'false';

      remove.textContent =
        'Remove';

      cancel.hidden = true;

      if (status) {
        status.textContent =
          'Unable to remove file.';
      }

      return;
    }

    this.savedValues[fieldId] =
      nextFiles;

    try {
      await window
        .AASupabaseClient
        .deletePlaybookFile({
          path: file.path
        });
    } catch (error) {
      console.error(
        'File record removed, but Storage cleanup failed:',
        error
      );
    }

    await this
      .renderSavedPlaybookFiles(
        fieldWrapper
      );
  }
);

cancel.addEventListener(
  'click',
  () => {
    remove.dataset.confirming =
      'false';

    remove.textContent =
      'Remove';

    cancel.hidden = true;
  }
);

actions.appendChild(remove);
actions.appendChild(cancel);
    }

    row.appendChild(name);
    row.appendChild(actions);

    container.appendChild(row);
  }
}

hydrateSavedPlaybookFiles() {
  this.root
    .querySelectorAll(
      '[data-field-type="upload_placeholder"]'
    )
    .forEach(
      (fieldWrapper) => {
        this.renderSavedPlaybookFiles(
          fieldWrapper
        );
      }
    );
}

bindFileUploads() {
  const workspace =
    window.AAWorkspaceContext?.get?.();

  const clientId =
    workspace?.clientId;

  this.root
    .querySelectorAll(
      '[data-field-type="upload_placeholder"]'
    )
    .forEach(
      (fieldWrapper) => {
        const input =
          fieldWrapper.querySelector(
            'input[type="file"]'
          );

        const status =
          fieldWrapper.querySelector(
            '[data-aa-playbook-upload-status]'
          );

        const uploadBox =
          fieldWrapper.querySelector(
            '.aa-playbook-upload-placeholder'
          );

        if (!input) {
          return;
        }

        const maxUploads =
          Number(
            uploadBox
              ?.dataset.maxUploads ||
            5
          );

        const canEdit =
          !this.reviewMode &&
          this.playbook &&
          window.AAPlaybookService
            ?.canEditPlaybook(
              this.playbook
            );

        input.disabled =
          !canEdit;

        if (!canEdit) {
          return;
        }

        input.addEventListener(
          'change',
          async () => {
            const selectedFiles =
              Array.from(
                input.files || []
              );

            if (!selectedFiles.length) {
              return;
            }

            const section =
              fieldWrapper.closest(
                '[data-section-id]'
              );

            const sectionId =
              section?.dataset
                .sectionId;

            const fieldId =
              fieldWrapper.dataset
                .fieldId;

            if (
              !clientId ||
              !this.playbookId ||
              !sectionId ||
              !fieldId
            ) {
              return;
            }

            let savedFiles =
              this.getSavedPlaybookFiles(
                fieldId
              );

            const remaining =
              maxUploads -
              savedFiles.length;

            if (remaining <= 0) {
              if (status) {
                status.textContent =
                  `Maximum of ${maxUploads} files reached.`;
              }

              input.value = '';
              input.disabled = true;
              return;
            }

            if (
              selectedFiles.length >
              remaining
            ) {
              if (status) {
                status.textContent =
                  `You can add ${remaining} more file${remaining === 1 ? '' : 's'}.`;
              }

              input.value = '';
              return;
            }

            input.disabled = true;

            try {
              for (
                const file of
                selectedFiles
              ) {
                if (status) {
                  status.textContent =
                    `Uploading ${file.name}...`;
                }

                const uploaded =
                  await window
                    .AASupabaseClient
                    .uploadPlaybookFile({
                      clientId,
                      playbookId:
                        this.playbookId,
                      fieldId,
                      file
                    });

                const newFile = {
                  ...uploaded,
                  uploadedAt:
                    new Date()
                      .toISOString()
                };

                const nextFiles = [
                  ...savedFiles,
                  newFile
                ];

                const success =
                  await window
                    .AAPlaybookService
                    .saveField({
                      playbookId:
                        this.playbookId,
                      sectionId,
                      fieldId,
                      value:
                        nextFiles
                    });

                if (!success) {
                  try {
                    await window
                      .AASupabaseClient
                      .deletePlaybookFile({
                        path:
                          newFile.path
                      });
                  } catch (
                    cleanupError
                  ) {
                    console.error(
                      'Unable to clean up failed upload:',
                      cleanupError
                    );
                  }

                  throw new Error(
                    'The file uploaded, but the Playbook record could not be saved.'
                  );
                }

                savedFiles =
                  nextFiles;

                this.savedValues[
                  fieldId
                ] = savedFiles;
              }

              await this
                .renderSavedPlaybookFiles(
                  fieldWrapper
                );
            } catch (error) {
              console.error(
                'Unable to upload Playbook file:',
                error
              );

              if (status) {
                status.textContent =
                  error?.message ||
                  'Unable to upload file.';
              }
            } finally {
              input.value = '';

              input.disabled =
                savedFiles.length >=
                maxUploads;
            }
          }
        );
      }
    );
}

updateSaveStatus(status) {
  this.saveStatus = status;

  const statusElement = document.querySelector('[data-aa-save-status]');

  if (!statusElement) return;

  statusElement.textContent = status === 'saving'
    ? 'Saving...'
    : status === 'error'
      ? 'Error saving'
      : 'Saved';
}
bindAutosave() {
  this.root.querySelectorAll('[data-field-id]').forEach((fieldWrapper) => {
    const canEdit =
  !this.reviewMode &&
  this.playbook
    ? window.AAPlaybookService.canEditPlaybook(
        this.playbook
      )
    : false;
    const inputs = fieldWrapper.querySelectorAll('input, textarea, select');

    if (!inputs.length) return;

    inputs.forEach((input) => {
  input.disabled = !canEdit;

  if (input.type === 'file') {
    return;
  }

  const eventType =
    input.type === 'checkbox' ||
    input.tagName === 'SELECT'
      ? 'change'
      : 'input';

      input.addEventListener(eventType, () => {
        const sectionElement = fieldWrapper.closest('[data-section-id]');
        const sectionId = sectionElement?.dataset.sectionId;
        const fieldId = fieldWrapper.dataset.fieldId;
        const fieldType = fieldWrapper.dataset.fieldType;

        if (!sectionId || !fieldId) return;

        const key = `${sectionId}:${fieldId}`;

        clearTimeout(this.saveTimers[key]);

        if (!canEdit) return;

        this.saveTimers[key] = setTimeout(() => {
          let value;

          if (fieldType === 'multi_select') {
            value = Array.from(fieldWrapper.querySelectorAll('input[type="checkbox"]:checked'))
              .map((checkbox) => checkbox.value);
          } else if (input.type === 'checkbox') {
            value = input.checked;
          } else {
            value = input.value;
          }

          window.AAPlaybookService.saveField({
            playbookId: this.playbookId,
            sectionId,
            fieldId,
            value
          }).then((success) => {
            this.updateSaveStatus(success ? 'saved' : 'error');
          });
        }, 700);
      });
    });
  });
}
updatePlaybookHeader() {
  if (!this.playbook || !window.AAPlaybookService) return;

  const status = window.AAPlaybookService.resolvePlaybookStatus(this.playbook);
  const canEdit = window.AAPlaybookService.canEditPlaybook(this.playbook);
  const statusLabel = window.AAPlaybookService.formatPlaybookStatus(status);

  this.root.classList.toggle('aa-playbook--locked', !canEdit);

  const monthNames = [
    '',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];

  const monthElements = document.querySelectorAll('[data-aa-playbook-month]');
  const summaryStatusElement = document.querySelector('.aa-playbook__summary-card strong');
  const summaryTextElement = document.querySelector('.aa-playbook__summary-card small');
  const headerStatusElement = document.querySelector('[data-aa-current-playbook-status]');

  monthElements.forEach((element) => {
  element.textContent = `${monthNames[this.playbook.month]} ${this.playbook.year}`;
});

  if (summaryStatusElement) {
    summaryStatusElement.textContent = statusLabel;
  }

  if (summaryTextElement) {
    const expiresAt =
      this.playbook.reopen_expires_at ||
      this.playbook.reopenExpiresAt;

    const reopenMessage =
      status === 'reopened' &&
      expiresAt
        ? `Editing available until ${new Date(
            expiresAt
          ).toLocaleString([], {
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit'
          })}`
        : '';

    summaryTextElement.textContent =
      this.reviewMode
        ? 'Headquarters review mode'
        : reopenMessage ||
          (
            canEdit
              ? 'Autosave is active'
              : 'Locked after the 15th. Request a 48-hour reopen if changes are needed.'
          );
  }

  if (headerStatusElement) {
    headerStatusElement.dataset.status = status;
    headerStatusElement.textContent = statusLabel;
  }

  const actions =
  document.querySelector(
    '[data-aa-playbook-actions]'
  );

const lockButton =
  document.querySelector(
    '[data-aa-lock-playbook]'
  );

const reopenButton =
  document.querySelector(
    '[data-aa-reopen-playbook]'
  );

const archiveButton =
  document.querySelector(
    '[data-aa-archive-playbook]'
  );

if (this.reviewMode) {
  if (actions) {
    actions.hidden = true;
  }

  if (lockButton) {
    lockButton.hidden = true;
  }

  if (reopenButton) {
    reopenButton.hidden = true;
  }

  if (archiveButton) {
    archiveButton.hidden = true;
  }

  this.root.classList.add(
    'aa-playbook--review-mode'
  );

  return;
}

if (actions) {
    const lifecycle = window.AAPlaybookService.getAllowedLifecycleActions(this.playbook);

    actions.hidden = !(
      lifecycle.canLock ||
      lifecycle.canReopen ||
      lifecycle.canArchive
    );

    if (lockButton) {
      lockButton.hidden = !lifecycle.canLock;
    }

    if (reopenButton) {
      reopenButton.hidden = !lifecycle.canReopen;
    }

    if (archiveButton) {
      archiveButton.hidden = !lifecycle.canArchive;
    }
  }

  this.scheduleReopenExpiryRefresh();
}

scheduleReopenExpiryRefresh() {
  if (this.reopenExpiryTimer) {
    window.clearTimeout(
      this.reopenExpiryTimer
    );

    this.reopenExpiryTimer = null;
  }

  if (
    !this.playbook ||
    !window.AAPlaybookService ||
    window.AAPlaybookService
      .resolvePlaybookStatus(
        this.playbook
      ) !== 'reopened'
  ) {
    return;
  }

  const expiresAt =
    this.playbook.reopen_expires_at ||
    this.playbook.reopenExpiresAt;

  if (!expiresAt) {
    return;
  }

  const remaining =
    new Date(expiresAt).getTime() -
    Date.now();

  if (remaining <= 0) {
    window.location.reload();
    return;
  }

  this.reopenExpiryTimer =
    window.setTimeout(
      () => {
        window.location.reload();
      },
      remaining + 750
    );
}

bindRepeatableActions() {
  if (this.reviewMode) {
    this.root
      .querySelectorAll(
        '[data-aa-add-row], [data-aa-delete-row]'
      )
      .forEach((button) => {
        button.hidden = true;
      });

    return;
  }
  this.root.querySelectorAll('[data-aa-add-row]').forEach((button) => {
    button.addEventListener('click', () => {
      const section = button.closest('[data-section-id]');
      if (!section) return;

      const sectionId = section.dataset.sectionId;
      const maxRows = Number(section.dataset.maxRows || 1);
      const body = section.querySelector('.aa-playbook-form-section__body');
      const isCardSection = sectionId === 'coupons' || sectionId === 'classes';
      const cardLabel = sectionId === 'classes' ? 'Class' : 'Coupon';
      const firstFields = isCardSection
        ? section.querySelector('.aa-playbook-coupon-card')
        : section.querySelector('.aa-playbook-form-section__fields');
      const limitMessage = section.querySelector('.aa-playbook-repeatable-limit');

      if (!body || !firstFields) return;

      const currentRows = isCardSection
        ? section.querySelectorAll('.aa-playbook-coupon-card').length
        : section.querySelectorAll('.aa-playbook-form-section__fields').length;

      if (currentRows >= maxRows) {
        button.disabled = true;
        if (limitMessage) limitMessage.hidden = false;
        return;
      }

      const newFields = firstFields.cloneNode(true);

      newFields.querySelectorAll('input, textarea, select').forEach((input) => {
        if (input.type === 'checkbox') {
          input.checked = false;
        } else {
          input.value = '';
        }
      });

      if (isCardSection) {
        const rowNumber = currentRows + 1;
        const header = newFields.querySelector('.aa-playbook-coupon-card__header strong');
        const deleteButton = newFields.querySelector('[data-aa-delete-row]');

        if (header) header.textContent = `${cardLabel} #${rowNumber}`;
        if (deleteButton) deleteButton.disabled = false;
      }

      body.insertBefore(newFields, button.closest('.aa-playbook-repeatable-controls'));

      const updatedRows = isCardSection
        ? section.querySelectorAll('.aa-playbook-coupon-card').length
        : section.querySelectorAll('.aa-playbook-form-section__fields').length;

      if (updatedRows >= maxRows) {
        button.disabled = true;
        if (limitMessage) limitMessage.hidden = false;
      }
    });
  });

  this.root.querySelectorAll('[data-section-id="coupons"], [data-section-id="classes"]').forEach((section) => {
    section.addEventListener('click', (event) => {
      const deleteButton = event.target.closest('[data-aa-delete-row]');
      if (!deleteButton || deleteButton.disabled) return;

      const sectionId = section.dataset.sectionId;
      const cardLabel = sectionId === 'classes' ? 'Class' : 'Coupon';
      const card = deleteButton.closest('.aa-playbook-coupon-card');

      if (!card) return;

      card.remove();

      section.querySelectorAll('.aa-playbook-coupon-card').forEach((rowCard, index) => {
        const header = rowCard.querySelector('.aa-playbook-coupon-card__header strong');
        const rowDeleteButton = rowCard.querySelector('[data-aa-delete-row]');

        if (header) header.textContent = `${cardLabel} #${index + 1}`;
        if (rowDeleteButton) rowDeleteButton.disabled = index === 0;
      });

      const maxRows = Number(section.dataset.maxRows || 1);
      const addButton = section.querySelector('[data-aa-add-row]');
      const limitMessage = section.querySelector('.aa-playbook-repeatable-limit');
      const updatedRows = section.querySelectorAll('.aa-playbook-coupon-card').length;

      if (addButton && updatedRows < maxRows) addButton.disabled = false;
      if (limitMessage && updatedRows < maxRows) limitMessage.hidden = true;
    });
  });
}

bindLifecycleActions() {
  const submitButton =
    document.querySelector(
      '[data-aa-lock-playbook]'
    );

  const reopenButton =
    document.querySelector(
      '[data-aa-reopen-playbook]'
    );

  const modal =
    document.querySelector(
      '[data-aa-reopen-modal]'
    );

  const agreement =
    modal?.querySelector(
      '[data-aa-reopen-agreement]'
    );

  const confirm =
    modal?.querySelector(
      '[data-aa-reopen-confirm]'
    );

  const message =
    modal?.querySelector(
      '[data-aa-reopen-message]'
    );

  const closeModal = () => {
    if (!modal) return;

    modal.hidden = true;
    document.body.classList.remove(
      'aa-modal-open'
    );

    if (agreement) {
      agreement.checked = false;
    }

    if (confirm) {
      confirm.disabled = true;
      confirm.textContent =
        'Reopen for 48 Hours';
    }

    if (message) {
      message.hidden = true;
      message.textContent = '';
      message.dataset.state = '';
    }
  };

  if (submitButton) {
    submitButton.addEventListener(
      'click',
      () => {
        this.handleSubmitPlaybook(
          submitButton
        );
      }
    );
  }

  if (reopenButton && modal) {
    reopenButton.addEventListener(
      'click',
      () => {
        modal.hidden = false;

        document.body.classList.add(
          'aa-modal-open'
        );

        window.setTimeout(
          () => agreement?.focus(),
          0
        );
      }
    );
  }

  modal
    ?.querySelectorAll(
      '[data-aa-reopen-cancel]'
    )
    .forEach((button) => {
      button.addEventListener(
        'click',
        closeModal
      );
    });

  agreement?.addEventListener(
    'change',
    () => {
      if (confirm) {
        confirm.disabled =
          agreement.checked !== true;
      }

      if (message) {
        message.hidden = true;
      }
    }
  );

  confirm?.addEventListener(
    'click',
    async () => {
      if (
        !agreement?.checked ||
        !this.playbookId ||
        !window.AAPlaybookService
          ?.requestPlaybookReopen
      ) {
        return;
      }

      confirm.disabled = true;
      confirm.textContent =
        'Reopening...';

      const result =
        await window.AAPlaybookService
          .requestPlaybookReopen({
            playbookId:
              this.playbookId,
            feeAgreed: true
          });

      if (!result?.success) {
        confirm.disabled = false;
        confirm.textContent =
          'Reopen for 48 Hours';

        if (message) {
          message.hidden = false;
          message.dataset.state =
            'error';
          message.textContent =
            result?.error?.message ||
            'Unable to reopen this Playbook. Please try again.';
        }

        return;
      }

      closeModal();
      window.location.reload();
    }
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (
        event.key === 'Escape' &&
        modal &&
        !modal.hidden
      ) {
        closeModal();
      }
    }
  );
}

async handleSubmitPlaybook(button) {
  if (!button || !this.playbookId || !window.AAPlaybookService) return;

  button.disabled = true;
  button.textContent = 'Submitting...';

  const success = await window.AAPlaybookService.submitPlaybook(this.playbookId);

  if (!success) {
    button.disabled = false;
    button.textContent = 'Submit Playbook';
    return;
  }

  const result = await window.AAPlaybookService.loadPlaybookById({
    playbookId: this.playbookId,
    clientId: window.AAWorkspaceContext?.get?.()?.clientId
  });

  if (result) {
    this.playbook = result.playbook;
    console.log('Loaded Playbook:', this.playbook);
    this.savedValues = this.normalizeSavedValues(result.values || {});
    this.updatePlaybookHeader();
  }
}

  renderUnavailablePlaybook() {
    this.root.innerHTML = `
      <div class="aa-playbook-empty-state" role="alert">
        <p>This Playbook cannot be opened from the selected Workspace.</p>
        <p>Return to the Workspace and choose a Playbook from its library.</p>
      </div>
    `;
  }

  renderEmptyState() {
    this.root.innerHTML = `
      <div class="aa-playbook-empty-state">
        <p>No Playbook sections have been configured yet.</p>
      </div>
    `;
  }
}

document.addEventListener('DOMContentLoaded', async () => {
  const engines =
    document.querySelectorAll(
      '[data-aa-playbook-engine]'
    );

  if (!engines.length) {
    return;
  }

  const requestedAdminClientId =
    new URLSearchParams(
      window.location.search
    ).get('aa_admin_client');

  const timeoutAt =
    Date.now() + 10000;
  let workspaceReady = false;

  while (Date.now() < timeoutAt) {
    const workspace =
      window.AAWorkspaceContext?.get?.();

    const adminClientReady =
      !requestedAdminClientId ||
      String(workspace?.clientId) ===
        String(requestedAdminClientId);

    if (
      workspace?.authResolved &&
      workspace?.clientId &&
      adminClientReady
    ) {
      workspaceReady = true;
      break;
    }

    await new Promise((resolve) =>
      setTimeout(resolve, 50)
    );
  }

  if (!workspaceReady) {
    engines.forEach((element) => {
      element.innerHTML = `
        <div class="aa-playbook-empty-state" role="alert">
          <p>Unable to confirm the selected Workspace.</p>
          <p>Please return to Headquarters and reopen this client's Workspace.</p>
        </div>
      `;
    });
    return;
  }

  engines.forEach((element) => {
    new AAPlaybookEngine(element);
  });
});